import React from "react";
import "./CaseOfficerEvaluationForm.scss"
import CaseOfficerEvaluationForm from "../../features/CaseOfficerEvaluationForm/CaseOfficerEvaluationForm";
const CaseOfficerEvaluation = () => {
  return (
    <div className="page-container">
      <CaseOfficerEvaluationForm/>
    </div>
  );
};
export default CaseOfficerEvaluation;
